"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _user = require("@/api/user");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'companyProductPdf',
  components: {},
  props: {},
  data: function data() {
    return {
      showPicker: false,
      value: '',
      list: '',
      columns: [],
      currentIndex: 0
    };
  },
  computed: {},
  watch: {},
  created: function created() {
    this.fetchData();
  },
  methods: {
    onConfirm: function onConfirm(value) {
      console.log('onConfirm');
      console.log(value);
      console.log(this.currentIndex);
      this.value = value;
      this.showPicker = false;
      location.target = '_blank';
      location.href = "/pdf/".concat(this.list[this.currentIndex]['file_path']);
      /* this.$router.push({
         name:'userCompanyProductPdfBrowser',
         query: {'url': `/pdf/${this.list[this.currentIndex]['file_path']}`,company_name:this.list[this.currentIndex]['company']['name']}
         })*/
    },
    change: function change(picker, value, index) {
      //   console.log(JSON.stringify({picker,value,index}))
      console.log(picker);
      this.currentIndex = index; /// console.log(value)
      //console.log(index)
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _user.getProductCompany)();

              case 2:
                res = _context.sent;
                this.list = res.data;
                this.columns = res.data.map(function (v) {
                  return v.company.name;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }
};
exports.default = _default;